import { SuiGrpcClient } from "@mysten/sui/grpc";

import { config } from "@/config";

import { getSuiNetwork, SuiNetwork } from "./index";

/**
 * MIGRATION: Sui JSON-RPC has been decommissioned on public Sui Foundation
 * full nodes (they now answer every JSON-RPC method with
 * `-32601 Method not found ... migrate to gRPC or GraphQL`). Everything that
 * used to go through `SuiClient` / `SuiJsonRpcClient` must talk gRPC instead.
 * See https://sdk.mystenlabs.com/sui/migrations/sui-2.0/json-rpc-migration
 *
 * `SuiGrpcClient` uses a grpc-web-over-fetch transport, so the same client
 * implementation works in the browser and in a Bun/Node process.
 *
 * NOTE: the base URL must point at a node speaking gRPC(-web) — the transport
 * appends `/<package>.<service>/<method>` to it. It is NOT the old JSON-RPC URL.
 */
const GRPC_FULLNODE_URLS: Record<SuiNetwork, string> = {
  mainnet: "https://fullnode.mainnet.sui.io:443",
  testnet: "https://fullnode.testnet.sui.io:443",
  devnet: "https://fullnode.devnet.sui.io:443",
};

/**
 * Resolves the gRPC endpoint for a network. `VITE_SUI_GRPC_URL` lets operators
 * point the app at a private/self-hosted node without a code change.
 */
export function getSuiGrpcUrl(network: SuiNetwork = getSuiNetwork()): string {
  return config.suiGrpcUrl || GRPC_FULLNODE_URLS[network];
}

export function createSuiGrpcClient(network: SuiNetwork = getSuiNetwork()): SuiGrpcClient {
  return new SuiGrpcClient({ network, baseUrl: getSuiGrpcUrl(network) });
}

/**
 * Process-wide client. Safe to share: the client is stateless apart from its
 * internal object/package cache, which is what we want to reuse.
 */
export const suiGrpcClient = createSuiGrpcClient();
